export default __webpack_public_path__ + "static/media/Users.7d187f37.svg";